/** @format */

import React, { useEffect, useState } from 'react'
import { _$, Icon, Button, Form } from '@king-design/react'
import styled from 'styled-components'
import EditGraphMetricFormItem from './EditGraphMetricFormItem'
import { cloneDeep } from 'lodash'
import { IMonitorGraphLineData, initMenberData } from './constants'
import { ProductItem } from 'src/utils/interface'
import ApiCommon from 'src/api/ApiCommon'
import { request } from 'src/utils'

interface EditGraphMetricFormProps {
  className?: string
  form: any
  metricList: IMonitorGraphLineData[]
  handleChangeMetrics: (value) => void
  handleLineCount: () => boolean
}

const EditGraphMetricForm: React.FC<EditGraphMetricFormProps> = ({
  className,
  form,
  metricList,
  handleChangeMetrics,
  handleLineCount
}) => {
  const [productList, setProductList] = useState<ProductItem[]>([])

  useEffect(() => {
    getProductList()
  }, [])

  // 获取支持自定义面板的产品线
  const getProductList = async () => {
    const result = await request(ApiCommon.getProudctGroup, {})
    if (result.code === 'Success') {
      setProductList(result?.data?.categories || [])
    }
  }

  // 添加metric
  const addMetric = async () => {
    const valid = await form.current.validate()
    if (valid) {
      if (handleLineCount()) {
        const cloneMetrics = cloneDeep(metricList || [])
        initMenberData.graphMetricId = Math.round(-1000 * Math.random())
        cloneMetrics.push(initMenberData)
        handleChangeMetrics(cloneMetrics)
      }
    }
  }

  return (
    <div className={className}>
      <Form starOnRequired ref={form} labelWidth={120}>
        {metricList?.length && productList?.length
          ? metricList.map((metric, index) => {
              return (
                <EditGraphMetricFormItem
                  key={`${metric.graphMetricId}-${index}`}
                  index={index}
                  productList={productList}
                  metricItem={metric}
                  metricList={metricList}
                  handleChangeMetrics={handleChangeMetrics}
                  handleLineCount={handleLineCount}
                />
              )
            })
          : null}
      </Form>
      <Button
        className="add-metric"
        onClick={() => {
          addMetric()
        }}
      >
        <Icon className="ion-plus-round" />
        {_$('新建监控项')}
      </Button>
    </div>
  )
}

export default styled(EditGraphMetricForm)`
  margin-top: 24px;
  .add-metric {
    display: block;
    margin-top: 32px;
    line-height: 12px;
    font-size: 12px;
    width: 100%;
    .k-icon {
      font-size: 14px;
      margin-right: 4px;
      margin-top: 4px;
    }
  }
`
